import { useContext } from 'react';

import { AnalyticsServiceContext } from '.';

export const useAnalyticsService = () => {
  return useContext(AnalyticsServiceContext)!;
};
